import { MAX_SCALE } from './Map'

// Calculates font size depending on max scaled floor image dimension
const getFontSize = (d, k) => {
  let fSize = 10

  if (k > MAX_SCALE / 10) {
    if (d > 1300) {
      fSize = 16
    } else if (d > 1200) {
      fSize = 14
    } else if (d > 1000) {
      fSize = 14
    } else if (d > 800) {
      fSize = 12
    }
  }

  return fSize
}

export default getFontSize
